import React from 'react'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'

import UnitExerciseListSkeleton from './UnitExerciseListSkeleton'

const UnitExerciseListPlaceholder = () => {
  return (
    <UnitExerciseListSkeleton
      titleSection={
        <LoadingBox width="150px" maxWidth="100%">
          &nbsp;
        </LoadingBox>
      }
      listSection={[...Array(6)].map((e, i) => (
        <LoadingBox
          key={`key-loader-section-${i}`}
          width="100%"
          height="214px"
          borderRadius="1x"
        />
      ))}
    />
  )
}

export default UnitExerciseListPlaceholder
